// skipcq: JS-W1028, JS-0128
import React, { useState, useCallback } from 'react';
import {
  Container,
  Box,
  Typography,
  CircularProgress,
  Grid,
  Tabs,
  Tab,
} from '@mui/material';
import DashboardLayout from '../../components/layout/DashboardLayout';
import TabPanel from '../../components/tabs/TabPanel';
import useBeerReviewsList from '../../hooks/useBeerReviewsList';
import useHospitalityReviewsList from '../../hooks/useHospitalityReviewsList';
import BeerReviewCard from '../../components/reviews/BeerReviewCard';
import HospitalityReviewCard from '../../components/reviews/HospitalityReviewCard';

/**
 * Reviews page component displaying the latest 20 beer reviews and hospitality reviews in tabs
 */
function Reviews() {
  const pageTitle = 'Reviews';
  const [activeTab, setActiveTab] = useState(0);
  const { reviews: beerReviews, loading: beerLoading, error: beerError } =
    useBeerReviewsList();
  const {
    reviews: hospitalityReviews,
    loading: hospitalityLoading,
    error: hospitalityError,
  } = useHospitalityReviewsList();

  const handleTabChange = useCallback((event, newValue) => {
    setActiveTab(newValue);
  }, []);

  return (
    <DashboardLayout title={pageTitle}>
      <Container fixed>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mb: 2,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="Review type tabs"
          >
            <Tab
              id="simple-tab-0"
              aria-controls="simple-tabpanel-0"
              label="Beer Reviews"
            />
            <Tab
              id="simple-tab-1"
              aria-controls="simple-tabpanel-1"
              label="Brewery Reviews"
            />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          {beerLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh"
              }}>
              <CircularProgress />
            </Box>
          ) : beerError ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh"
              }}>
              <Typography variant="h6" color="error">
                Error loading beer reviews: {beerError}
              </Typography>
            </Box>
          ) : (
            <Grid
              container
              spacing={0}
              direction="column"
              style={{ minHeight: '100vh', paddingTop: '20px' }}
              sx={{
                alignItems: "center"
              }}
            >
              {beerReviews.length === 0 ? (
                <Typography variant="h6" sx={{
                  color: "text.secondary"
                }}>
                  No beer reviews found
                </Typography>
              ) : (
                beerReviews.map((review) => (
                  <BeerReviewCard key={review.id} review={review} />
                ))
              )}
            </Grid>
          )}
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          {hospitalityLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh"
              }}>
              <CircularProgress />
            </Box>
          ) : hospitalityError ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh"
              }}>
              <Typography variant="h6" color="error">
                Error loading hospitality reviews: {hospitalityError}
              </Typography>
            </Box>
          ) : (
            <Grid
              container
              spacing={0}
              direction="column"
              style={{ minHeight: '100vh', paddingTop: '20px' }}
              sx={{
                alignItems: "center"
              }}
            >
              {hospitalityReviews.length === 0 ? (
                <Typography variant="h6" sx={{
                  color: "text.secondary"
                }}>
                  No hospitality reviews found
                </Typography>
              ) : (
                hospitalityReviews.map((review) => (
                  <HospitalityReviewCard key={review.id} review={review} />
                ))
              )}
            </Grid>
          )}
        </TabPanel>
      </Container>
    </DashboardLayout>
  );
}

export default Reviews;

